import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {toast} from 'react-hot-toast'
import Sidebar from "../components/user/sidebar";
import { useNavigate } from "react-router-dom";
import {useSelector} from 'react-redux'
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Container,
} from "@mui/material";

const Contract = () => {
  const params = useParams();
  const token = useSelector((state)=> state.user.token)
  // Define state to store the fetched contract
  const [contract, setContract] = useState(null);
  // Define state to track changes to contract details
  const [editedContract, setEditedContract] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  console.log(contract)

  useEffect(() => {
    // Define an asynchronous function to fetch the contract
    const fetchContract = async () => {
      try {
        // Perform the fetch operation
        const response = await fetch(`https://salama-api.onrender.com/contract_infos/${params.id}`);
        if (!response.ok) {
          // Check if the response status is not OK (e.g., 404 or 500 error)
          throw new Error('Failed to fetch contract');
        }

        // Parse the response as JSON
        const contractData = await response.json();

        // Set the contract data in the state
        setContract(contractData.contract_info);
        // Set the editedContract state initially to the same data
        setEditedContract(contractData.contract_info);
      } catch (err) {
        // Handle any errors that occurred during the fetch
      }
    };

    // Call the fetchContract function when the component mounts
    fetchContract();
  }, [params.id]); // Include params.id in the dependency array to refetch when the ID changes

  // Handle changes in input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the editedContract state with the changed value
    setEditedContract({
      ...editedContract,
      [name]: value,
    });
  };

  console.log(editedContract)

  // Handle contract update submission
  const handleUpdate = async (e) => {
    e.preventDefault()

    try {
      await fetch(`https://salama-api.onrender.com/contract_infos/${params.id}`, {
        method: 'PUT', 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(editedContract),
      })

      .then(response => {
        if (!response.ok) {
          // Handle error responses here
          return response.json().then(errorData => {
            throw new Error(errorData.message || 'Network response was not ok');
          });
  
        } else {
            // Request was successful
            return response.json()
        }
      })
    .then(data => {
      // Handle the response data here
      console.log("Transaction Data:", data);
      setLoading(false)
      toast.success(data.message)
      navigate(`/user`)
    })

      // Assuming successful update, you can optionally set a success message or perform other actions
    } catch (err) {
      // Handle any errors that occurred during the update
    }
  };

  // Render the contract details or an error message with input fields for editing
  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
    <Sidebar />
    <Paper
      elevation={3}
      style={{ flex: "1", padding: "2rem", minHeight: "calc(100vh - 150px)" }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Add a Contract
      </Typography>
      <form onSubmit={handleUpdate }>
        <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
        <TextField
            fullWidth
            label="Product Details"
            name="product_name"
            variant="outlined"
            value={editedContract?.product_name || ""}
            onChange={handleInputChange}
            required
            InputLabelProps={{
              shrink: true,
            }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"product_price"} // Use optional chaining and provide a fallback
              name="product price"
              variant="outlined"
              value={contract?.product_price || ""}
              required
              InputProps={{
                readOnly: true,
              }}    
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"seller_email"} // Use optional chaining and provide a fallback
              name="Seller Email"
              variant="outlined"
              value={contract?.buyer_email || ""}
              required
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"buyer_email"} // Use optional chaining and provide a fallback
              name="Buyer Email"
              variant="outlined"
              value={contract?.seller_email || ""}
              required
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="payment_terms"
              name="payment_terms"
              type="text"
              variant="outlined"
              value={contract?.payment_terms}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="salama_pay_terms"
              name="salama_pay_terms"
              type="text"
              variant="outlined"
              value={contract?.salama_terms}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="governing_law"
              name="governing_law"
              type="text"
              variant="outlined"
              value={contract?.governing_law}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="dispute_resolution"
              name="dispute_resolution"
              type="text"
              variant="outlined"
              value={contract?.dispute_resolution}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="agreement"
              name="agreement"
              type="text"
              variant="outlined"
              value={contract?.agreement}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="termination"
              name="termination"
              type="text"
              variant="outlined"
              value={contract?.termination}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>

        </Grid>
        <Box mt={3}>
        <Typography variant="body2" color="textSecondary">
          Please note that completing you agree to the terms of the contract.
        </Typography>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            disabled={loading}
          >
            { loading ? "loading..." : "Create Contract" }
          </Button>
        </Box>
      </form>
    </Paper>
  </Container>

  );
}

export default Contract;